import React from 'react';
function MessageSquare({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 14.667a1.778 1.778 0 01-1.778 1.777H7.556L4 20V5.778A1.778 1.778 0 015.778 4h12.444A1.778 1.778 0 0120 5.778v8.889z"
      />
    </svg>
  );
}

export default MessageSquare;
